import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

export const isLocalEmulator = process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_USE_EMULATORS === "true";

const firebaseConfig = {
  apiKey: "AIzaSyDVkjXI6spmVZrmRwJGNAtlcoXYKMM92-Y",
  authDomain: "shiftbridge-852b5.firebaseapp.com",
  projectId: "shiftbridge-852b5",
  storageBucket: "shiftbridge-852b5.firebasestorage.app",
  messagingSenderId: "556351033981",
  appId: "1:556351033981:web:80dec93773a7ddd179d714",
};

const app = initializeApp(isLocalEmulator ? {
  ...firebaseConfig,
  apiKey: "local-preview-only",
  projectId: "demo-shiftbridge-preview",
  authDomain: "localhost",
  storageBucket: "demo-shiftbridge-preview.appspot.com",
} : firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
console.log("SHIFTBRIDGE FIREBASE MODE", {
  isLocalEmulator,
  nodeEnv: process.env.NODE_ENV,
  useEmulators: process.env.REACT_APP_USE_EMULATORS,
  projectId: app.options.projectId,
  storageBucket: app.options.storageBucket,
});

// Explicit local development only. Production builds always use the existing
// Firebase configuration, never an emulator or a test identity.
if (isLocalEmulator) {
  if (!["localhost", "127.0.0.1"].includes(window.location.hostname)) {
    throw new Error("Emulator mode is restricted to a local preview.");
  }
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}

export default app;
